<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics" class="vx-card">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="230" />
          <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="200" />
          <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Hoş Geldin {{ userName() }},</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            Nitro Mekatronik
          </p>
        </vx-card>
      </div>
    </div>

    <template v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '9') != null">
      <div class="vx-row ml-5 mr-5" style="margin-top:30px; margin-bottom:99px;flex-wrap: nowrap;">
        <div class="vx-col ml-12 w-full">
          <div style="margin:5px;text-align: center;font-size: 20px; color:red">
            <label><b>NİTRO VARLIKLARI DÖVİZ TÜRÜNDE DEĞİŞİM</b></label>
          </div>
          <div class="w-full">
            <apexchart type="line" :options="fortuneOptions" :series="seriesNitroFortune"></apexchart>
          </div>
          <vs-prompt
            v-if="popupFortuneDetail"
            style="z-index: 100001;"
            :vs-title="
              $moment(nitroFortuneDayList[selectedFortuneIndex].fortuneDate).format('DD.MM.YYYY') +
                ' ' +
                $moment(nitroFortuneDayList[selectedFortuneIndex].fortuneDate)
                  .locale('tr')
                  .format('dddd') +
                ' günü varlık detayları '
            "
            vs-accept-text="Kaydet"
            vs-cancel-text="Kapat"
            vs-button-cancel="border"
            :vs-active.sync="popupFortuneDetail"
            :vs-buttons-hidden="true"
            @vs-cancel="popupFortuneDetail = false"
          >
            <div class="vx-row w-full ">
              <div class="vx-col w-full">
                <vs-table :maxItems="150" :data="nitroFortuneDayList[selectedFortuneIndex].nitroFortuneDetailList">
                  <template slot="thead">
                    <!-- <vs-th width="15px">Id</vs-th> -->
                    <!-- <vs-th width="110px">Gün</vs-th> -->
                    <vs-th width="175px">Açıklama</vs-th>
                    <vs-th width="150px">Orjinal</vs-th>
                    <vs-th width="100px"> ₺ </vs-th>
                    <vs-th width="100px"> $ </vs-th>
                    <vs-th width="100px"> € </vs-th>
                    <vs-th width="100px"> ¥ </vs-th>
                    <vs-th width="250px"> Çapraz Kurlar</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <tbody style="cursor: pointer;" :key="tr.hrShiftId" v-for="(tr, i) in data">
                      <vs-tr>
                        <template>
                          <!-- <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                            <b>
                              {{
                                $moment(tr.fortuneDate).format("DD.MM.YYYY") +
                                  " " +
                                  $moment(tr.fortuneDate)
                                    .locale("tr")
                                    .format("dddd")
                              }}</b
                            >
                          </vs-td> -->
                          <vs-td class="pt-3 pb-3" style="white-space: nowrap;">
                            <b> {{ tr.description + " - " + tr.currencyNameOriginal }}</b>
                          </vs-td>
                          <vs-td class="pt-0 pb-1">
                            <b> {{ tr.totalAmountOriginal + " " + tr.currencyNameOriginal }}</b>
                          </vs-td>

                          <vs-td class="pt-0 pb-1">
                            <b> {{ tr.totalAmountTl }}</b>
                          </vs-td>
                          <vs-td class="pt-0 pb-1">
                            <b> {{ tr.totalAmountUsd }}</b>
                          </vs-td>
                          <vs-td class="pt-0 pb-1">
                            <b> {{ tr.totalAmountEuro }}</b>
                          </vs-td>
                          <vs-td class="pt-0 pb-1">
                            <b> {{ tr.totalAmountYuan }}</b>
                          </vs-td>
                          <vs-td class="pt-0 pb-1">
                            <b> {{ tr.fxRateUsd + " - " + tr.fxRateEuro + " - " + tr.fxRateYuan }}</b>
                          </vs-td>
                        </template>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </div>
          </vs-prompt>
        </div>

        <div v-if="1 == 2" class="vx-col md:w-3/12 w-full">
          <div style="margin:5px;text-align: center;font-size: 20px; color:red">
            <label><b>NİTRO EN ÇOK SATIŞ YAPAN (TL CONSOLIDATE)</b></label>
          </div>
          <div>
            <vs-table search noDataText="Personel yok" :maxItems="10" :pagination="true" :data="fotu">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/ConsolidatedPersonnelWatch/' + tr.userId + '/' + 'Sale'" style="margin-left:15px;margin-top:5px;color:blue" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <div class="vx-row ml-5 mr-5" style="margin-top:30px; margin-bottom:99px;flex-wrap: nowrap;">
        <div class="vx-col mr-12 w-full">
          <div style="margin:5px;text-align: center;font-size: 20px; color:red">
            <label><b>NİTRO GÜN BAZLI SATIŞ GRAFİĞİ</b></label>
          </div>
          <div>
            <apexchart type="line" :options="chartOptions" :series="series"></apexchart>
          </div>
        </div>
      </div>
      <reconcile v-if="reconcilePopupParent" :reconcilePopupProp="reconcilePopupParent" :customerIdProp="customerIdProp" @ReconcilePopupClosedChildEmit="ReconcilePopupClosedParentEmitCatch($event)"></reconcile>
      <div class="vx-row ml-5 mr-5" style="margin-top:30px; margin-bottom:99px">
        <div v-if="1 == 2" class="vx-col md:w-4/12 w-full">
          <div style="margin:5px;text-align: center;font-size: 20px; color:red">
            <label><b>NİTRO BÖLGE BAZLI SATIŞ</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(nitroSaleRegionList) }} {{ " TL" }}</b>
          </div>
          <div>
            <vs-table search noDataText="Bölge yok" :maxItems="10" :pagination="true" :data="nitroSaleRegionList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex">
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left:15px;margin-top:5px;color:blue" target="_blank"><b>Hesap</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <div style="margin:5px;text-align: center;font-size: 20px; color:red">
            <label><b>BORÇLU MÜŞTERİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedCustomerList) }} {{ " TL" }}</b>
          </div>
          <div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedCustomerList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin:5px;text-align: center;font-size: 20px; color:red">
            <label><b>ALACAKLI MÜŞTERİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedToCustomerList) }} {{ " TL" }}</b>
          </div>
          <div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedToCustomerList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

      <!-- TEDARİKÇİLER -->
      <!-- TEDARİKÇİLER -->
      <!-- TEDARİKÇİLER -->
      <div class="vx-row ml-5 mr-5" style="margin-top:30px; margin-bottom:99px">
        <!-- BORÇLU TEDARİKÇİLER -->
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>BORÇLU TEDARİKÇİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedSupplierList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="owedSupplierList" class>İndir</JsonExcel>
            </div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedSupplierList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <!-- ALACAKLI TEDARİKÇİLER -->
        <div class="vx-col md:w-1/2 w-full">
          <div style="margin: 5px; text-align: center; font-size: 20px; color: red;">
            <label><b>ALACAKLI TEDARİKÇİLER</b></label>
          </div>
          <div style="margin: 5px; text-align: center; font-size: 15px;">
            <b> {{ getSumOfList(owedToCustomerSupplierList) }} {{ " TL" }}</b>
          </div>
          <div>
            <div style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="owedToCustomerSupplierList" class>İndir</JsonExcel>
            </div>
            <vs-table search noDataText="Müşteri yok" :maxItems="10" :pagination="true" :data="owedToCustomerSupplierList">
              <template slot="thead">
                <vs-th class="w-1/3">Kasa Adı</vs-th>
                <vs-th class="w-1/6">Tutar</vs-th>
                <vs-th class="w-1/6">İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.accountId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.accountDescription.substr(0, 30) + " - " + tr.currencyName }}
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    {{ tr.amount + " " + tr.currencyName }}
                  </vs-td>

                  <td class="flex" style="margin-left:-22px">
                    <a
                      href="#"
                      class="danger"
                      @click.stop="
                        reconcilePopupParent = true;
                        customerIdProp = tr.customerId;
                      "
                      style="margin-left: 15px; margin-top: 5px;"
                      ><b>Reconcile</b></a
                    >
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: orange;" target="_blank"><b>Müşteri</b></a>
                    <a :href="'/AccountMovementWatch/' + tr.accountId" style="margin-left: 15px; margin-top: 5px; color:  #7393B3 ;" target="_blank"><b>Hesap</b></a>
                    <a :href="'/SaleByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: red;" target="_blank"><b>Satış</b></a>
                    <a :href="'/MoneyTransferByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkgray;" target="_blank"><b>Transfer</b></a>
                    <a :href="'/IncomeByCustomerId/' + tr.customerId" style="margin-left: 15px; margin-top: 5px; color: darkred;" target="_blank"><b>Ödeme</b></a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { repository } from "../../_services/repository.js";
import apexchart from "vue-apexcharts";
import JsonExcel from "vue-json-excel";
import Reconcile from "../Account/Reconcile";

export default {
  data() {
    return {
      reconcilePopupParent: false,
      customerIdProp: null,
      popupFortuneDetail: false,
      saleForRegionPersonnelList: [],
      owedSupplierList: [],
      nitroMostSalePersonnelList: [],
      nitroSaleRegionList: [],
      saleForOutOfRegionList: [],
      saleForRegionList: [],
      salePerformanceDayList: [],
      nitroFortuneDayList: [],
      owedCustomerList: [],
      owedToCustomerList: [],
      owedToCustomerSupplierList: [],
      saleForRegionDashboardConsolidatedTLList: [],

      searchModel: { startDate: this.startDate, finishDate: this.finishDate },

      nitroSales: {},

      chartOptions: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [], //Yatay Değerler---> Gün
        },
      },
      series: [
        {
          name: "Toplam Tutar ( TL )",
          data: [], //Dikey Değerler--->Satış toplamı olacak
        },
      ],

      fortuneTlList: [],
      fortuneUsdList: [],
      fortuneEuroList: [],
      fortuneYuanList: [],
      seriesNitroFortune: [],
      fortuneXAxisList: [],
      selectedFortuneIndex: null,
    };
  },
  components: {
    apexchart,
    JsonExcel,
    Reconcile,
  },

  created() {
    let currentDate = new Date();
    this.searchModel.finishDate = currentDate.toISOString().substr(0, 10);
    this.searchModel.startDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1)).toISOString().substr(0, 10);

    this.GetCases();
  },

  methods: {
    ReconcilePopupClosedParentEmitCatch: async function(v) {
      this.reconcilePopupParent = false;
      console.log("reconcile child is closed", v);
      this.$vs.loading();
      await this.GetOwedCustomer();
      await this.GetOwedToCustomer();
      await this.GetOwedSupplier();
      this.$vs.loading.close();
    },

    userName() {
      var u = this.$store.state.userData.userName;
      return u.split(" ")[0];
    },

    getSumOfList: function(list) {
      let sumTL = 0.0;

      list.forEach((element) => {
        sumTL += element.amountTL;
      });

      return sumTL.toFixed(2);
    },

    GetCases: async function() {
      this.$vs.loading();

      /*this.GetNitroMostSalePersonnel(), this.GetNitroSaleRegion(),*/

      await Promise.all([this.GetSalePerformanceDay(), this.GetNitroFortuneDay(), this.GetOwedCustomer(), this.GetOwedToCustomer(), this.GetOwedSupplier()]);
      this.$vs.loading.close();
    },

    GetSalePerformanceDay: async function() {
      this.salePerformanceDayList = await repository.postEntity("Accounting/GetSalePerformanceDay", this.searchModel).then((r) => r.list);

      let xAxisList = [];
      let yAxisList = [];

      this.salePerformanceDayList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);

        xAxisList.push(row.date.substr(0, 10));
        yAxisList.push(row.amount);
      });

      this.series = [
        {
          data: yAxisList,
        },
      ];

      this.chartOptions = {
        tooltip: {
          theme: this.$store.state.theme,
        },
        xaxis: { categories: xAxisList },
      };
    },

    GetNitroFortuneDay: async function() {
      this.fortuneXAxisList = [];
      this.seriesNitroFortune = [];

      this.nitroFortuneDayList = await repository.postEntity("Accounting/GetNitroFortuneDay", this.searchModel).then((r) => r.list);

      let xAxisList = [];
      let yAxisList = [];

      this.nitroFortuneDayList.forEach((row) => {
        // this.chartOptions.xaxis.categories.push(row.date.substr(0, 10));
        // this.series[0].data.push(row.amount);
        xAxisList.push(row.fortuneDate.substr(0, 10));

        this.fortuneTlList.push(row.totalAmountTl);
        this.fortuneUsdList.push(row.totalAmountUsd);
        this.fortuneEuroList.push(row.totalAmountEuro);
        this.fortuneYuanList.push(row.totalAmountYuan);

        yAxisList.push(row.totalAmountTl);
      });

      this.fortuneXAxisList = xAxisList;

      this.seriesNitroFortune = [
        {
          name: "₺",
          data: this.fortuneTlList,
        },
        {
          name: "$",
          data: this.fortuneUsdList,
        },
        {
          name: "€",
          data: this.fortuneEuroList,
        },
        {
          name: "¥",
          data: this.fortuneYuanList,
        },
      ];
    },

    GetNitroMostSalePersonnel: async function() {
      this.nitroMostSalePersonnelList = await repository.postEntity("Accounting/GetNitroMostSalePersonnel", {}).then((r) => r.list);
    },

    GetOwedSupplier: async function() {
      this.owedSupplierList = await repository.postEntity("Accounting/GetOwedSupplier", {}).then((r) => r.list);
    },

    GetNitroSaleRegion: async function() {
      this.nitroSaleRegionList = await repository.postEntity("Accounting/GetNitroSaleRegion", {}).then((r) => r.list);
    },

    GetOwedCustomer: async function() {
      this.owedCustomerList = await repository.postEntity("Accounting/GetOwedCustomer", {}).then((r) => r.list);
    },

    GetOwedToCustomer: async function() {
      let owedToList = await repository.postEntity("Accounting/GetOwedToCustomer", {}).then((r) => r.list);

      this.owedToCustomerList = owedToList.filter((r) => r.isSupplier == 0);
      this.owedToCustomerSupplierList = owedToList.filter((r) => r.isSupplier == 1);
    },

    openFortunePopupDetail: async function(index) {
      this.popupFortuneDetail = true;
      this.selectedFortuneIndex = index;
    },
  },

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.popupFortuneDetail) this.popupFortuneDetail = false;
      }
    });
  },

  computed: {
    ////////////////////////////
    fortuneOptions: function() {
      return {
        tooltip: {
          theme: this.$store.state.theme,
        },
        colors: ["#d05e12", "#1279d0", "#d01298", "#4cd012"],
        xaxis: {
          categories: this.fortuneXAxisList,
        },
        chart: {
          events: {
            click: (event, chartContext, config) => {
              const dp = config.dataPointIndex;
              // use the series position of the clicked marker to find the corresponding x axis data at that point in the series
              this.openFortunePopupDetail(dp);
            },
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboard-analytics {
  .greet-user {
    height: 213px;
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
